import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import axios from 'axios';
import endpoints, { getBackendUrl } from '../../../endpoints';
import { useSelector, useDispatch } from 'react-redux'

export default function ContentNoteModal(props) {
    const [data, setData] = useState(props.data)
    const [value, setValue] = useState('')
    const token = useSelector((state) => state.auth.token)
    
    const save = async () => {
        const note = props.data.note
        
        let uri = getBackendUrl(endpoints.feedcontents_ext_note, token).replace('{id}', props.data.id)
        try {
            let res = await axios.put(uri, {
                name: note.name,
                value: value,
            })
            props.onSave()
        } catch (e) {
            
        }
    }
    
    const clear = async () => {
        const note = props.data.note
        
        let uri = getBackendUrl(endpoints.feedcontents_ext_note, token).replace('{id}', props.data.id)
        try {
            let res = await axios.put(uri, {
                name: note.name,
                value: '',
            })
            props.onSave()
        } catch (e) {
            
        }
    }
    
    useEffect(() => {
        if (props.data?.note.type === 'checkbox') {
            const checkboxSave = async () => {
                const note = props.data.note
        
                let uri = getBackendUrl(endpoints.feedcontents_ext_note, token).replace('{id}', props.data.id)
                try {
                    const newValue = note.value ? '' : note.title
                    let res = await axios.put(uri, {
                        name: note.name,
                        value: newValue,
                    })
                    props.onSave(newValue)
                } catch (e) {

                }
            }
            checkboxSave()
        } else {
            setValue(props.data?.note.value ?? '')
        }
    }, [props.data])
        
    return (
        <Dialog open={props.data && props.data.note.type !== 'checkbox' ? true : false} onClose={() => {props.onClose()}} fullWidth maxWidth="xs" >
            <form onSubmit={(e) => {e.preventDefault()}}>
                <DialogTitle id="alert-dialog-title">
                    {props.data?.note.title}
                </DialogTitle>
                <DialogContent>
                    {props.data?.note.type == 'int' ?
                    <TextField 
                        fullWidth
                        label="Value"
                        variant="filled"
                        type="number"
                        defaultValue={props.data?.note.value}
                        onChange={(e) => {setValue(e.target.value)}}
                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                    />
                    : null }
                    {props.data?.note.type == 'string' ?
                    <TextField
                        select
                        fullWidth
                        label="Value"
                        defaultValue={props.data?.note.value ?? ''}
                        variant="filled"
                        onChange={(e) => {setValue(e.target.value)}}
                    >
                        {props.data?.note.options?.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                    : null }
                    {props.data?.note.type == 'bool' && props.data?.note.label ?
                    <FormControlLabel 
                        control={<Checkbox 
                                    defaultChecked={props.data?.note.value ? true : false} 
                                    onChange={(e) => {setValue(e.target.checked ? props.data?.note.label : '' )}}
                                />}
                        label={props.data?.note.label} 
                    />
                    : null }
                    {props.data?.note.type == 'bool' && props.data?.note.options ?
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue={props.data?.note.value ?? ''}
                        onChange={(e) => {setValue(e.target.value)}}
                    >
                        {props.data?.note.options?.map((option) => (
                            <FormControlLabel key={option} value={option} control={<Radio />} label={option} />
                        ))}
                    </RadioGroup>
                    : null }
                </DialogContent>
                <DialogActions>
                    <Button onClick={clear}>Clear</Button>
                    <Stack sx={{flexGrow:1}} />
                    <Button onClick={() => {props.onClose()}}>Cancel</Button>
                    <Button type="submit" onClick={save} autoFocus>Save</Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}